import { SvgIcon, SvgIconProps } from '@mui/material';
import { white } from '@/lib/colours';

export function ArrowBackIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Icon" clipPath="url(#clip0_1194_26073)">
          <path
            id="Vector"
            d="M14.2504 8.25297H5.87285L9.53285 4.59297C9.82535 4.30047 9.82535 3.82047 9.53285 3.52797C9.24035 3.23547 8.76785 3.23547 8.47535 3.52797L3.53285 8.47047C3.24035 8.76297 3.24035 9.23547 3.53285 9.52797L8.47535 14.4705C8.76785 14.763 9.24035 14.763 9.53285 14.4705C9.82535 14.178 9.82535 13.7055 9.53285 13.413L5.87285 9.75297H14.2504C14.6629 9.75297 15.0004 9.41547 15.0004 9.00297C15.0004 8.59047 14.6629 8.25297 14.2504 8.25297Z"
            fill="currentcolor"
          />
        </g>
        <defs>
          <clipPath id="clip0_1194_26073">
            <rect
              width="18"
              height="18"
              fill={white[900]}
              transform="translate(0 0.00292969)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
